import { render } from "./RecordingRule.vue?vue&type=template&id=59e902be&scoped=true"
import script from "./RecordingRule.vue?vue&type=script&lang=js"
export * from "./RecordingRule.vue?vue&type=script&lang=js"

import "./RecordingRule.vue?vue&type=style&index=0&id=59e902be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e902be"]])

export default __exports__